export default "__VITE_ASSET__BfhjZM$I__"